import React, { useState } from "react";
import { Input } from "../../components/Form";
import { changePasswordApi } from "../../services/auth/Auth";
import usePasswordToggle from "../../hooks copy/usePasswordToggle";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button/Button";
import useButtonLoader from "../../hooks/UseButtonLoader";

const ChangePassword = () => {
  const [inputValue, setInputValue] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState({});
  // const { removeCookie } = useCookie();
  const [buttonref, buttonLoader] = useButtonLoader("Change Password");

  const [inputType, Icon] = usePasswordToggle("small");
  const [inputType2, Icon2] = usePasswordToggle("small");
  const [inputType3, Icon3] = usePasswordToggle("small");

  const navigate = useNavigate();

  const handleValidation = () => {
    let errorMessage = {};
    let status = true;

    if (!inputValue.oldPassword) {
      errorMessage["oldPassword"] = "Please enter old password";
      status = false;
    }
    if (!inputValue.newPassword) {
      errorMessage["password"] = "Please enter password";
      status = false;
    }
    if (!inputValue.confirmPassword) {
      errorMessage["confirmPassword"] = "Please enter password confirm";
      status = false;
    }
    if (inputValue?.newPassword && inputValue?.confirmPassword) {
      if (inputValue.confirmPassword !== inputValue.newPassword) {
        toast.error("password & confirm password should be same");
        status = false;
      }
    }
    setError(errorMessage);
    return status;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
  };
  const changePasswordHandler = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      try {
        // if (inputValue.confirmPassword !== inputValue.password) {
        //     toast.error("password & confirm password should be same");
        // }
        buttonLoader(true);
        const res = await changePasswordApi(inputValue);
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message);
          localStorage.clear();
          setInputValue({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          navigate("/");
        } else {
          toast.error(res?.data?.message);
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        buttonLoader(false);
      }
    }
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">Change Password</h4>
        </div>

        <div className="row">
          <form
            // onSubmit={changePasswordHandler}
            className="col-md-10 mx-auto my-3"
          >
            <div className="CommonForm">
              <div className="form-group col-6">
                <Input
                  type={inputType}
                  name="oldPassword"
                  value={inputValue?.oldPassword}
                  onChange={onChangeHandler}
                  placeholder="Enter Old Password"
                  className={`form-control password `}
                  label={"Old password"}
                  error={error.oldPassword}
                  required
                />
                <span className="icon">{Icon}</span>
              </div>

              <div className="form-group col-6">
                <Input
                  type={inputType2}
                  name="newPassword"
                  value={inputValue?.newPassword}
                  onChange={onChangeHandler}
                  placeholder="Enter New Password"
                  className={`form-control password `}
                  label={"New password"}
                  error={error.password}
                  required
                />
                <span className="icon">{Icon2}</span>
              </div>

              {/* <div className="form-group col-6">
                                <Input
                                    type={inputType3}
                                    name="confirmPassword "
                                    value={inputValue.confirmPassword}
                                    onChange={onChangeHandler}
                                    placeholder="Enter Confirm Password"
                                    className={`form-control password `}
                                    label={"Re enter password"}
                                    error={error.confirmPassword}
                                    required
                                />
                                <span className="icon">{Icon3}</span>
                            </div> */}

              <div className="form-group col-6">
                <Input
                  type={inputType3}
                  name="confirmPassword"
                  value={inputValue?.confirmPassword}
                  onChange={onChangeHandler}
                  placeholder="Enter Confirm Password"
                  className={`form-control password`}
                  label={"Re enter password"}
                  error={error.confirmPassword}
                  required
                />
                <span className="icon">{Icon3}</span>
              </div>
              <div className=" ">
                <button
                  ref={buttonref}
                  type="submit"
                  className="btn_size"
                  onClick={changePasswordHandler}
                >
                  Change Password
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
